import React, { HTMLAttributes } from "react";

import classNames from "classnames";
import { iconsList } from "../../utilities/iconsList";

const SliderArrowButton = ({
  className,
  style,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  slideCount,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  currentSlide,
  ...props
}: HTMLAttributes<HTMLButtonElement> & { slideCount: number; currentSlide: number }) => (
  <button
    {...props}
    style={{ ...style, display: "inline-flex" }}
    className={classNames(className, "flex justify-center items-center")}
  >
    <svg width={20} height={20}>
      <use xlinkHref={iconsList.chevronIcon} />
    </svg>
  </button>
);

export default SliderArrowButton;

